import { createContext, useRef, useState } from "react";
import { getLocalStoragedata } from "../helpers/encryptHelpers/storageHelper";

export const CreateJobPostContext = createContext({});

export function CreateJobPostContextProvider({ children }) {
  const [stepperCurrentSteps, setStepperCurrentSteps] = useState(0);
  const [completedStep, setCompletedStep] = useState(0);

  // const [stepsOpenHandler, setStepsOpenHandler] = useState({
  //   location: true,
  //   job: true,
  //   description: true,
  // });

  const [searchValue, setSearchValue] = useState("");
  const [searchDropDownData, setSerchDropDownData] = useState([]);
  const [isSearchDropdownOpen, setSearchDropdownIsOpen] = useState(true);
  const [selectedCategoryID, setSelectedCategoryID] = useState(null);

  const [selectedCategoryDescription, setSelectedCategoryDescription] =
    useState("");

  const [locationValues, setLocationValues] = useState({
    country: undefined,
    conuntryName: undefined,

    state: undefined,
    suburb: undefined,

    postalCodetype1: undefined,
    postalCodetype2: undefined,

    district: undefined,
    districtName: undefined,
    city: undefined,
    cityName: undefined,
  });

  const [jobValues, setjobValues] = useState({
    jobOne: true,
    jobTwo: false,
    jobThree: false,
  });
  const [descriptionValues, setdescriptionValues] = useState("");

  const [countrySelectorData, setCountrySelectorData] = useState([]);
  const [location1SelectorData, setLocation1SelectorData] = useState([]);
  const [location2SelectorData, setLocation2SelectorData] = useState([]);

  const [selectedJobType, setSelectedJobType] = useState(
    getLocalStoragedata("searchSelectedJobTypeName")
  );
  const [taskerList, setTaskerList] = useState([]);

  const [allCountryValues, setAllCountryValues] = useState();
  const [selectedCountryType, setSelectedCountryType] = useState(1);

  const searchRef = useRef(null);

  return (
    <CreateJobPostContext.Provider
      value={{
        searchValue,
        setSearchValue,
        searchDropDownData,
        setSerchDropDownData,
        isSearchDropdownOpen,
        setSearchDropdownIsOpen,
        selectedCategoryID,
        setSelectedCategoryID,

        selectedCategoryDescription,
        setSelectedCategoryDescription,

        stepperCurrentSteps,
        setStepperCurrentSteps,
        completedStep,
        setCompletedStep,

        // stepsOpenHandler,
        // setStepsOpenHandler,

        locationValues,
        setLocationValues,

        jobValues,
        setjobValues,
        descriptionValues,
        setdescriptionValues,

        countrySelectorData,
        setCountrySelectorData,
        location1SelectorData,
        setLocation1SelectorData,
        location2SelectorData,
        setLocation2SelectorData,

        selectedJobType,
        setSelectedJobType,

        taskerList,
        setTaskerList,

        allCountryValues,
        setAllCountryValues,
        selectedCountryType,
        setSelectedCountryType,
        searchRef,
      }}
    >
      {children}
    </CreateJobPostContext.Provider>
  );
}
